import { queryOptions } from '@tanstack/react-query';
import ms from 'ms';

import { AICodingJob, fetchAICodingJobs } from 'services/backend/aiCodingJobs';

const REFETCH_INTERVAL_MS = ms('3s');

const hasJobsInProgress = (jobs: AICodingJob[] | undefined): boolean => {
  if (!jobs || jobs.length === 0) {
    return false;
  }

  return jobs.some(
    (job) => job.status === 'PENDING' || job.status === 'IN_PROGRESS',
  );
};

const getRefetchInterval = (jobs: AICodingJob[] | undefined) => {
  return hasJobsInProgress(jobs) ? REFETCH_INTERVAL_MS : false;
};

export const aiCodingJobQueries = {
  all: () => ['aiCodingJobs'],
  byQuestion: (opts: { questionId: number }) =>
    queryOptions({
      queryFn: () => fetchAICodingJobs({ questionId: opts.questionId }),
      queryKey: [...aiCodingJobQueries.all(), 'question', opts.questionId],
      refetchInterval: (query) => getRefetchInterval(query.state.data),
      staleTime: 0,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
    }),
};
